import React from 'react';
import '../Navbar.css';
// import TtyOutlinedIcon from '@mui/icons-material/TtyOutlined';

const Navbar = ({size, setShow}) => {
  return (
    <nav>
        <div className="nav_box">
            <div className="nav_left"> 
            <span><img src="https://lh3.googleusercontent.com/p/AF1QipP2qEANQ1Zi_pMr3EzLYX59FArorqVHd0cFnjlw=s1360-w1360-h1020"></img> </span>
            
            </div>
            <div className="nav_middle">
            <span className="my_shop" onClick={()=>setShow(true)}>
                Ocean Of Cakes 
            </span>
            </div>
            <div className='nav_right'>                
            
                <i className="fas fa-mobile"></i>
            
                <span className='mobile_no'>
                    Mobile - 9940485258
                </span>
            </div>    
                
                <div className="nav_right cart" onClick={()=>setShow(false)}>
                    <span>
                        <i className="fas fa-cart-plus"></i>
                    </span>
                    <span>{size}</span>
                </div>
            
        </div>
    </nav>
  )
}

export default Navbar